import MyModal from "../MyModal"
import React, { useState, useEffect, useRef, useCallback } from "react"
import { toast } from "react-toastify"
import { Swiper, SwiperSlide } from "swiper/react"
import { Navigation } from "swiper/modules"
import { CITYS, PRICES } from "../../utils/constants"

import "swiper/css"
import "swiper/css/navigation"
import {
    ClockChannel,
    WeathersChannels,
    SgInfoChannel,
    ServerName,
    PriceChannels,
    OnClientsChannel,
    OnAdminsChannel,
    JailChannel,
    NewClientsChannel,
    Connection,
    DateChannel,
    Permissions,
    BanClientsChannel,
    DynamicChannel,
    TempChannel,
    AutoRank,
    AutoCountry,
    AutoOs,
} from "./slides/Slides"
import { createManagerBot } from "../../services/managerBotApis"
import actionHelper from "../../lib/actionHelper"
import { getPermList } from "../../services/permissionsApis"
import StaffList from "./slides/StaffList"
import IdleTime from "./slides/IdleTime"
import DeathRoomChannel from "./slides/DeathRoomChannel"
import MultiRank from "./slides/MultiRank"
import MoveRequest from "./slides/MoveRequest"
import { useAuth } from "../../lib/useAuth"
import { useSocket, useSocketEvent } from "../../contexts/SocketContext"
import ForbiddenMsgNotify from "./slides/ForbiddenMsgNotify"
import VoiceStatusChange from "./slides/VoiceStatusChange"

const CreateManagerBotModal = ({ isOpen, toggleModal, botList }) => {
    const { user } = useAuth()
    const { isConnected, sendMessage } = useSocket()

    const [selectedPerms, setSelectedPerms] = useState({})
    const [serverData, setServerData] = useState({})
    const [templateNameIsValid, setTemplateNameIsValid] = useState(false)
    const [permList, setPermList] = useState(null)
    const [indexSlide, setIndexSlide] = useState({})
    const swiperRef = useRef(null)

    const goToSlide = (slideIndex) => {
        if (slideIndex && swiperRef.current) {
            swiperRef.current.slideTo(slideIndex)
        }
    }
    const calculatePermissions = (permissions, selectedPerms) => {
        let amount = permissions.find((p) => p.name == "createBot").price
        for (let permName of Object.keys(selectedPerms)) {
            const { checked, multi } = selectedPerms[permName]
            if (checked) {
                const permission = permissions.find((p) => p.name == permName)
                if (multi) {
                    for (let i = 0; i < multi; i++) {
                        amount += permission.price
                    }
                }
            }
        }
        return amount
    }

    const slides = [
        { name: "dateChannels", element: (index = null) => <DateChannel index={index} serverData={serverData} /> },
        { name: "clockChannels", element: (index = null) => <ClockChannel index={index} serverData={serverData} /> },
        {
            name: "onClientsChannel",
            element: (index = null) => <OnClientsChannel index={index} serverData={serverData} />,
        },
        {
            name: "onAdminsChannel",
            element: (index = null) => <OnAdminsChannel index={index} serverData={serverData} />,
        },
        { name: "priceChannels", element: (index = null) => <PriceChannels index={index} serverData={serverData} /> },
        { name: "jailChannels", element: (index = null) => <JailChannel index={index} serverData={serverData} /> },
        {
            name: "newClientsChannel",
            element: (index = null) => <NewClientsChannel index={index} serverData={serverData} />,
        },
        {
            name: "banClientsChannel",
            element: (index = null) => <BanClientsChannel index={index} serverData={serverData} />,
        },
        {
            name: "weathersChannels",
            element: (index = null) => <WeathersChannels index={index} serverData={serverData} />,
        },
        { name: "sgInfoChannels", element: (index = null) => <SgInfoChannel index={index} serverData={serverData} /> },
        { name: "serverName", element: (index = null) => <ServerName index={index} serverData={serverData} /> },
        {
            name: "dynamicChannels",
            element: (index = null) => <DynamicChannel index={index} serverData={serverData} />,
        },
        { name: "tempChannel", element: (index = null) => <TempChannel index={index} serverData={serverData} /> },
        { name: "autoRank", element: (index = null) => <AutoRank index={index} serverData={serverData} /> },
        { name: "autoCountry", element: (index = null) => <AutoCountry index={index} serverData={serverData} /> },
        { name: "autoOs", element: (index = null) => <AutoOs index={index} serverData={serverData} /> },
        { name: "staffList", element: (index = null) => <StaffList index={index} serverData={serverData} /> },
        { name: "idleTime", element: (index = null) => <IdleTime index={index} serverData={serverData} /> },
        {
            name: "deathRoomChannel",
            element: (index = null) => <DeathRoomChannel index={index} serverData={serverData} />,
        },
        { name: "multiRank", element: (index = null) => <MultiRank index={index} serverData={serverData} /> },
        { name: "moveRequest", element: (index = null) => <MoveRequest index={index} serverData={serverData} /> },
        {
            name: "forbiddenMsgNotify",
            element: (index = null) => <ForbiddenMsgNotify index={index} serverData={serverData} />,
        },
        {
            name: "voiceStatusChange",
            element: (index = null) => <VoiceStatusChange index={index} serverData={serverData} />,
        },
    ]

    const permsInputs = {
        clockChannels: {
            isMulti: true,
            inputs: ["id", "format"],
        },
        dateChannels: {
            isMulti: true,
            inputs: ["id", "format"],
        },
        onClientsChannel: {
            isMulti: false,
            inputs: ["id", "format", "ignoreSgList"],
        },
        onAdminsChannel: {
            isMulti: false,
            inputs: ["id", "format", "adminSgList"],
        },
        priceChannels: {
            isMulti: false,
            inputs: (() => {
                let obj = {}
                PRICES.forEach((curr) => {
                    obj[curr.en] = ["id", "format"]
                })

                return obj
            })(),
        },
        jailChannels: {
            isMulti: true,
            inputs: ["id", "sgId", "time", "format"],
        },
        newClientsChannel: {
            isMulti: false,
            inputs: ["id", "clientDesc", "format", "descFormat"],
        },
        banClientsChannel: {
            isMulti: false,
            inputs: ["id", "nameFormat", "descriptionFormat"],
        },
        weathersChannels: {
            isMulti: false,
            inputs: (() => {
                let obj = {}
                CITYS.forEach((city) => {
                    obj[city.en] = ["id", "format"]
                })

                return obj
            })(),
        },
        sgInfoChannels: {
            isMulti: true,
            inputs: ["id", "sgId", "nameFormat", "descriptionFormat"],
        },
        serverName: {
            isMulti: false,
            inputs: ["format"],
        },
        dynamicChannels: {
            isMulti: true,
            inputs: ["id", "minChannels", "format", "maxChannels", "maxClients", "joinPower", "iconId"],
        },
        tempChannel: {
            isMulti: false,
            inputs: ["listenId", "parentId", "cgId", "nameFormat", "pokeFormat", "iconId"],
        },
        autoRank: {
            isMulti: false,
            inputs: ["canUseIds", "maxMsg", "ranks", "msgFormat"],
        },
        autoCountry: {
            isMulti: false,
            inputs: ["ignoreSgList", "countryList"],
        },
        autoOs: {
            isMulti: false,
            inputs: ["ignoreSgList", "mac", "windows", "android", "linux", "iOS"],
        },
        staffList: {
            isMulti: true,
            inputs: ["id", "clickable", "staffSgList", "descFormat", "usersFormat"],
        },
        idleTime: {
            isMulti: false,
            inputs: ["timeList", "ignoreSgList"],
        },
        deathRoomChannel: {
            isMulti: false,
            inputs: ["id", "ignoreSgList", "msg", "kickMsg"],
        },
        multiRank: {
            isMulti: false,
            inputs: ["rankId", "multiRanks"],
        },
        moveRequest: {
            isMulti: false,
            inputs: ["canUseList", "joinMsg", "moveMsg"],
        },
        forbiddenMsgNotify: {
            isMulti: false,
            inputs: ["sgListToNotify", "ignoreSgList", "forbiddenWords", "pokeFormat"],
        },
        voiceStatusChange: {
            isMulti: false,
            inputs: ["sgListToNotify", "ignoreSgList", "adminPokeFormats", "clientPokeFormats"],
        },
    }

    const handlePermList = useCallback((permList) => {
        setPermList(permList)
    }, [])

    useSocketEvent("permList", handlePermList)

    useEffect(() => {
        if (isOpen && isConnected) {
            sendMessage("getPermList")
            setSelectedPerms({})
        }
    }, [isOpen, isConnected])
    useEffect(() => {
        let slideIndex = 2
        let obj = {}
        for (let key of Object.keys(selectedPerms)) {
            const perm = selectedPerms[key]
            obj[key] = slideIndex
            slideIndex += perm.multi ? parseInt(perm.multi) : 1
        }
        setIndexSlide(obj)
    }, [selectedPerms])

    const validateTemplateName = (e) => {
        const label = document.getElementById("templateNameLabel")
        const value = e.target.value
        const inUse = botList?.find((b) => b.templateName == value)
        if (inUse) {
            setTemplateNameIsValid(false)
            label.innerHTML = '<div class="show_info text-sm text-red-400">نامعتبر</div>'
        } else {
            setTemplateNameIsValid(true)
            label.innerHTML = '<div class="show_info text-sm text-green-400">معتبر</div>'
        }
    }

    const createBotFormSubmitHandler = (e) => {
        e.preventDefault()
        if (!templateNameIsValid) {
            toast.error("اسم تمپلیت تکراری میباشد")
        }
        const form = new FormData(e.target)
        let data = {}
        data.templateName = form.get("bot-templatename")
        data.panelId = form.get("panel-id")

        data.selectedPerms = selectedPerms

        data.conn = {
            host: form.get("connection-host"),
            serverPort: form.get("connection-serverport"),
            queryPort: form.get("connection-queryport"),
            queryPassword: form.get("connection-querypassword"),
            username: form.get("connection-username"),
            botName: form.get("connection-botname"),
        }
        data.channels = {}
        for (let key of Object.keys(selectedPerms)) {
            if (!selectedPerms[key].checked) {
                continue
            }
            const { isMulti, inputs } = permsInputs[key]

            if (!isMulti) {
                data.channels[key] = {}
                if (Array.isArray(inputs)) {
                    for (let input of inputs) {
                        if (typeof data.channels[key] == "object") {
                            const value = form.get(`${key}-${input}`)
                            data.channels[key][input] = value
                        }
                    }
                } else {
                    // this is for priceChannels and weatherChannels
                    for (let j of Object.keys(inputs)) {
                        data.channels[key][j] = {}
                        for (let c of inputs[j]) {
                            data.channels[key][j][c] = form.get(`${key}-${j}-${c}`)
                        }
                    }
                }
            } else if (isMulti) {
                data.channels[key] = []
                const multiCount = selectedPerms[key].multi
                for (let i = 0; i < multiCount; i++) {
                    let obj = {}
                    for (let input of inputs) {
                        if (typeof obj == "object") {
                            const value = form.get(`${key}-${i}-${input}`)
                            obj[input] = value
                        }
                    }
                    if (obj) {
                        data.channels[key].push(obj)
                    }
                }
            }
        }
        const amount = calculatePermissions(permList, selectedPerms)
        actionHelper({
            confirmation: {
                label: `مقدار ${amount} از حساب شما کم میشود ایا مطمئن هستید؟`,
                actionLabel: "ساخت بات",
                color: "success",
            },
            callback: () =>
                createManagerBot(data).then((res) => {
                    console.log(res)
                    if (res?.data?.isConnected) {
                        toast.success("به سرور متصل شد")
                    } else {
                        toast.error("به سرور متصل نشد")
                    }
                }),
            texts: {
                success: "بات مدیریتی با موفقیت ساخته شد",
                pending: "درحال ساخت بات",
            },
        })
    }

    const handlePermissionsOnChange = (permName) => {
        const isChecked = document.getElementById(permName).checked
        const multi = document.getElementById(`${permName}-multi`)?.value

        setSelectedPerms((selectedPerms) => {
            let newObject = { ...selectedPerms }
            newObject[permName] = {}
            newObject[permName]["checked"] = isChecked
            if (multi) {
                newObject[permName]["multi"] = multi
            }

            return newObject
        })
    }
    return (
        <>
            <MyModal isOpen={isOpen} toggleModal={toggleModal} height="500px" width="900px">
                <div className="flex-col  h-full">
                    <form className="h-full" onSubmit={createBotFormSubmitHandler}>
                        <Swiper
                            modules={[Navigation]}
                            onSwiper={(swiper) => (swiperRef.current = swiper)} // Capture Swiper instance
                            slidesPerView={1}
                            className="h-[85%] "
                            simulateTouch={false}
                            navigation
                        >
                            <SwiperSlide>
                                <Permissions
                                    user={user}
                                    goToSlide={goToSlide}
                                    indexSlide={indexSlide}
                                    validateTemplateName={validateTemplateName}
                                    permList={permList}
                                    handlePermissionsOnChange={handlePermissionsOnChange}
                                />
                            </SwiperSlide>
                            <SwiperSlide>
                                <Connection user={user} setServerData={setServerData} />
                            </SwiperSlide>
                            {Object.keys(selectedPerms).map((key, index) => {
                                const el = slides.find((s) => s.name === key).element

                                if (selectedPerms[key].checked && selectedPerms[key].multi) {
                                    const multi = selectedPerms[key].multi
                                    let elements = []
                                    for (let i = 0; i < multi; i++) {
                                        elements.push(
                                            <SwiperSlide className="h-full y-scroll" key={i}>
                                                {el(i)}
                                            </SwiperSlide>,
                                        )
                                    }
                                    return <>{elements}</>
                                } else if (selectedPerms[key].checked) {
                                    return <SwiperSlide className="h-full y-scroll">{el()}</SwiperSlide>
                                }
                            })}
                        </Swiper>

                        <button type="submit" class="styled-button mt-5 ml-2 w-full success">
                            ساخت بات
                        </button>
                    </form>
                </div>
            </MyModal>
        </>
    )
}

export default CreateManagerBotModal
